import React from "react";
import { AnimatedSection } from "./IntersectionObserver.tsx";

interface ProcessStep {
  number: string;
  title: string;
  description: string;
}

const Process: React.FC = () => {
  const steps: ProcessStep[] = [
    {
      number: "01",
      title: "Исследование",
      description: "Мы анализируем ваш бренд, рынок и технические требования"
    },
    {
      number: "02", 
      title: "Дизайн",
      description: "Дизайн редакционного качества, адаптированный под ваш модный бренд"
    },
    {
      number: "03",
      title: "Разработка", 
      description: "Индивидуальная разработка с использованием современного технологического стека"
    },
    {
      number: "04",
      title: "Запуск и поддержка",
      description: "Выходим в прод с постоянным обслуживанием и оптимизацией"
    }
  ];

  return (
    <section id="process" className="process-section pad-xlarge">
      <div className="dark-container">
        <AnimatedSection>
          <div className="section-header">
            <h2 className="display-medium">Наш процесс</h2>
            <p className="body-medium section-subtitle">
              От концепции до запуска мы сопровождаем вас на каждом этапе
            </p>
          </div>
        </AnimatedSection>
        
        <div className="process-timeline">
          {steps.map((step: ProcessStep, index: number) => (
            <AnimatedSection key={index} delay={index + 1}>
              <div className="process-step">
                <div className="step-number display-large">{step.number}</div>
                <div className="step-content">
                  <h3 className="heading-2">{step.title}</h3>
                  <p className="body-medium">{step.description}</p>
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;